import "core-js/modules/es.array.concat.js";
import React from 'react';
import { getProductTypeLabel, getFundsListPath } from '@finect/front-resources/Products';
import { useTheme } from 'styled-components';
import { Section } from '../../Section';
import { List } from '../../Products';
export var ManagementCompanyFunds = function ManagementCompanyFunds(_ref) {
  var productType = _ref.productType,
    managementCompany = _ref.managementCompany,
    funds = _ref.funds,
    subscriptions = _ref.subscriptions,
    onFollow = _ref.onFollow;
  var theme = useTheme();
  var handleFollow = onFollow ? onFollow : function () {};
  return React.createElement(Section, {
    bottomMargin: true,
    title: "Todos los ".concat(getProductTypeLabel(productType, 'shortPlural', 'lowercase'), " de ").concat(managementCompany.name),
    subtitle: "".concat(productType.plural, " de ").concat(managementCompany.name, " ordenados por rentabilidad a 3 a\xF1os."),
    link: {
      text: "Ver los ".concat(funds.paging.totalItems, " ").concat(getProductTypeLabel(productType, 'shortPlural', 'lowercase'), " de ").concat(managementCompany.name),
      href: getFundsListPath(theme, productType, {
        company: managementCompany.id,
        order: '-totalNetAsset'
      })
    }
  }, React.createElement(List, {
    products: funds.items,
    layout: "carousel",
    subscriptions: subscriptions,
    onFollow: handleFollow
  }));
};